import { prefixObjectValues } from '../utils';

const nav = {
  layout: 'layout',
  profileSection: 'profile-section',
  dashboardLink: 'dashboard',
  profileLink: 'profile',
  aoiLink: 'aoiLink',
  settingsLink: 'settingsLink',
  employmentSection: 'employment-section',
  employmentHistory: 'employmentHistoryLink',
  academicsSection: 'academics-section',
  educationLink: 'educationLink',
  trainingLink: 'trainingLink',
  licenseSection: 'license-section',
  medicalLicenseLink: 'medLicenseLink',
  deaLicenseLink: 'deaLicenseLink',
  cdsLicenseLink: 'cdsLicenseLink',
  certificationsSection: 'certification-section',
  boardCertificationsLink: 'boardCertsLink',
  certificationsLink: 'certsLink',
  cmeSection: 'cme-section',
  cmeLink: 'cmeLink',
  privilegesSection: 'privileges-section',
  privilegesLink: 'privilegesLink',
  insuranceSection: 'insurance-section',
  malpracticeInsuranceLink: 'malPracticeInsuranceLink',
  malpracticeInsuranceClaims: 'malPracticeClaimsLink',
  documentSection: 'documents-section',
  attestationLink: 'attestationLink',
  referencesLink: 'referencesLink',
  documentsLink: 'documentsLink',
  downloadMyDataLink: 'download-my-data',
};

export default prefixObjectValues(nav, 'nav-drawer');
